import React, { RefObject, useLayoutEffect } from 'react';
import { Maximize24x24 } from 'Shared/Icons/Maximize';
import { Minimize24x24 } from 'Shared/Icons/Minimize';

type PropType = {
  mediaRef: RefObject<HTMLMediaElement>;
  isMaximized: boolean;
  updateIsMaximized: (selectedValue: boolean) => void;
};

const MaximizeControls = ({ mediaRef, isMaximized, updateIsMaximized }: PropType) => {
  useLayoutEffect(() => {
    document.onfullscreenchange = () => {
      if (document.fullscreenElement === null) {
        updateIsMaximized(false);
      }
    };

    return () => {
      document.onfullscreenchange = null;
    };
  });

  const maximize = () => {
    mediaRef.current?.parentElement?.parentElement?.requestFullscreen();
    updateIsMaximized(true);
  };

  const minimize = () => {
    document.exitFullscreen();
    updateIsMaximized(false);
  };

  return isMaximized ? (
    <Minimize24x24 onClick={minimize} css={{ cursor: 'pointer' }} />
  ) : (
    <Maximize24x24 onClick={maximize} css={{ cursor: 'pointer' }} />
  );
};

export default MaximizeControls;
